export const dashboardMetricTypeSearchParam = 'dashboardMetricType';
export const fromDashboardSearchParam = 'fromDashboard';

export const isFromDashboard = (checkForMetricType: boolean = false) => {
  const queryParams = new URLSearchParams(window.location.search);
  return (
    !!queryParams.get(fromDashboardSearchParam) &&
    (!checkForMetricType || !!queryParams.get(dashboardMetricTypeSearchParam))
  );
};

export const getDashboardMetricType = () => {
  const urlSearchParams = window.location.search;
  const queryParams = new URLSearchParams(urlSearchParams);
  return queryParams.get(dashboardMetricTypeSearchParam);
};
